export enum ProjectStatuses {
  Proposed = 0,
  Active = 1,
  Closed = 2,
}
